import { mockApiResponses } from './mockData';
import apiClient from '../client';

// This is a mock API service that uses mock data
// In production, replace these with actual API calls using apiClient

class MockApiService {
    // Authentication endpoints
    async login(email, password) {
        try {
            return await mockApiResponses.login(email, password);
        } catch (error) {
            throw error;
        }
    }

    async logout() {
        try {
            localStorage.removeItem('family_tree_token');
            localStorage.removeItem('family_tree_refresh_token');
            localStorage.removeItem('family_tree_user');
            return { data: { success: true } };
        } catch (error) {
            throw error;
        }
    }

    // Members endpoints
    async createMember(firstName, lastName, phoneNumber) {
        try {
            return await mockApiResponses.createMember({
                firstName,
                lastName,
                phoneNumber,
            });
        } catch (error) {
            throw error;
        }
    }

    async verifySlug(slug) {
        try {
            return await mockApiResponses.verifySlug(slug);
        } catch (error) {
            throw error;
        }
    }

    async getFamilyTree(slug) {
        try {
            return await mockApiResponses.getFamilyTree(slug);
        } catch (error) {
            throw error;
        }
    }

    async getMember(memberId) {
        try {
            // Mock implementation
            return {
                data: {
                    success: true,
                    member: {},
                },
            };
        } catch (error) {
            throw error;
        }
    }

    async updateMember(memberId, data) {
        try {
            return await mockApiResponses.updateMember(memberId, data);
        } catch (error) {
            throw error;
        }
    }

    async deleteMember(memberId) {
        try {
            return {
                data: {
                    success: true,
                },
            };
        } catch (error) {
            throw error;
        }
    }

    // Images endpoints
    async uploadImage(file, memberId) {
        try {
            return await mockApiResponses.uploadImage(file, memberId);
        } catch (error) {
            throw error;
        }
    }

    async addGoogleDriveImage(memberId, gdriveLinkData) {
        try {
            return {
                data: {
                    success: true,
                    image: {
                        id: `img-${Date.now()}`,
                        memberId,
                        ...gdriveLinkData,
                        type: 'gdrive',
                    },
                },
            };
        } catch (error) {
            throw error;
        }
    }

    async deleteImage(imageId) {
        try {
            return {
                data: {
                    success: true,
                },
            };
        } catch (error) {
            throw error;
        }
    }

    // Relationships endpoints
    async createRelationship(parentId, childId, relationshipType) {
        try {
            return {
                data: {
                    success: true,
                    relationship: {
                        id: `rel-${Date.now()}`,
                        parentId,
                        childId,
                        type: relationshipType,
                    },
                },
            };
        } catch (error) {
            throw error;
        }
    }

    async updateRelationship(relationshipId, data) {
        try {
            return {
                data: {
                    success: true,
                    relationship: { id: relationshipId, ...data },
                },
            };
        } catch (error) {
            throw error;
        }
    }

    async deleteRelationship(relationshipId) {
        try {
            return {
                data: {
                    success: true,
                },
            };
        } catch (error) {
            throw error;
        }
    }
}

export default new MockApiService();
